import React, { useState } from 'react';
import './CustNInstNDownloadClient.css'; // Create this CSS file for custom styles

export default function CustNInstNDownloadClient() {
  // Hardcoded versions
  const versions = ['1.0.0', '1.1.0', '2.0.0'];
  
  // State to hold the selected version
  const [selectedVersion, setSelectedVersion] = useState(versions[0]);

  const handleVersionChange = (e) => {
    setSelectedVersion(e.target.value);
  };

  return (
    <div className="download-client-container">
      <label htmlFor="version-select">Choose a version:</label>
      <select
        id="version-select"
        value={selectedVersion}
        onChange={handleVersionChange}
        className="version-select"
      >
        {versions.map((version, index) => (
          <option key={index} value={version}>
            {version}
          </option>
        ))}
      </select>

      <button className="download-button">
        Download Client for version {selectedVersion}
      </button>
    </div>
  );
}
